interface ArticleTitleProps{
    title: string
}

// TODO: Sanitize html

function ArticleTitle({title}: ArticleTitleProps) {
    return <span dangerouslySetInnerHTML={{ __html: title }} />
}

export default ArticleTitle